import { render, staticRenderFns } from "./shipmentsByVolume.vue?vue&type=template&id=1840bf40"
import script from "./shipmentsByVolume.vue?vue&type=script&lang=js"
export * from "./shipmentsByVolume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports